/**
 * Máscaras numéricas pt-BR para InputNumber (Ant Design).
 * Usuário digita só dígitos; o sistema escala e formata as casas decimais.
 */

export function decimalFormatter(value, fractionDigits = 2) {
    if (value === null || value === undefined || value === '') return '';
    const numberValue = typeof value === 'string' ? parseFloat(String(value).replace(',', '.')) : value;
    if (!Number.isFinite(numberValue)) return '';
    return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    }).format(numberValue);
}

export function decimalParser(value, fractionDigits = 2) {
    if (!value && value !== 0) return null;
    const onlyNumbers = String(value).replace(/[^\d]/g, '');
    if (!onlyNumbers) return null;
    const divisor = 10 ** fractionDigits;
    return parseInt(onlyNumbers, 10) / divisor;
}

/**
 * Props prontas para Ant Design InputNumber com máscara só-dígitos.
 * @param {number} fractionDigits casas decimais (ex.: 1 para pontos/real, 2 para moeda, 4 para CPM)
 * @param {object} extras props extras (prefix, min, style, etc.)
 */
export function decimalInputProps(fractionDigits = 2, extras = {}) {
    const step = 1 / 10 ** fractionDigits;
    return {
        style: { width: '100%' },
        step,
        precision: fractionDigits,
        formatter: (value) => decimalFormatter(value, fractionDigits),
        parser: (value) => decimalParser(value, fractionDigits),
        inputMode: 'numeric',
        ...extras,
    };
}

export function currencyInputProps(extras = {}) {
    return decimalInputProps(2, { prefix: 'R$ ', ...extras });
}
